module.exports = __webpack_public_path__ + "static/media/advictorem-webby-statue.ad22f1ba.png";